export default __webpack_public_path__ + "static/trend-lines-4ed9ce128b0b64ce9b556ebdb771cf0e.png";